import React, { } from "react"
import { View, Text, Image, Pressable } from "react-native"

import { getRandInt0to10 } from "../../services/RandomIntGen"
import { getImagePath, getNameInitials } from "../../services/CommonUtils"
import { getChemistProfilePicUrl } from "../../services/chemist/ChemistStoreUtils"

import { StoreStaticPaymentMethodsList } from "../../constants/ConstantsMapping"

import AppTheme from "../../../AppTheme"
import AppStyles from "../../../AppStyles"
import TextStyle from "../../../TextStyle"
import Colors from "../../constants/AppColors"

import PaginationItem from "../Carousel/Pagination";

export const ChemistStoreInformation = (props) => {
    const icon = props.informationIcon
    const title = props.informationTitle
    const marginTop = props?.marginTop ?? 0
    return (<View style={[AppStyles.flexRowStart, { marginTop: marginTop }]}>
        <Image style={{ height: 12, width: 12 }}
            source={{ uri: getImagePath(icon) }} />
        <Text style={[TextStyle.text12, {
            width: AppTheme.appWidth - 48, flexWrap: "wrap",
            marginLeft: 4, color: Colors.grey.lightText
        }]}>{title}</Text>
    </View>)
}

export const ChemistStoreServices = (props) => {
    const serviceIcon = props.serviceIcon
    const customView = props?.customView
    return (<View style={[AppStyles.flexRowStart, { marginBottom: 24 }]}>
        <Image style={{ height: 14, width: 14, marginRight: 8 }}
            source={{ uri: getImagePath(serviceIcon) }} />
        {customView}
    </View>)
}

export const StorePictureView = (storePicData, index, scallingFactor,
    viewWidth, viewHeight, callback) => {
    const imageUrl = storePicData[index]['publicUrl']
    return <Pressable onPress={() => callback(storePicData, index)}
        onLongPress={() => { console.log('### long press') }}>
        <Image style={{ width: viewWidth, height: viewHeight }}
            source={{ uri: imageUrl }} />
    </Pressable>
}

export const StorePicturesCarouselPagination =
    (carouselData, progressValue) => {
        return (<View style={[AppStyles.flexRowEnd, {
            backgroundColor: Colors.white,
            padding: 4, borderRadius: 12,
            position: "absolute", bottom: 8, right: 16,

        }]}>
            {carouselData.map((data, index) => {
                return (<PaginationItem key={index} index={index}
                    width={4} height={4}
                    animValue={progressValue} length={carouselData.length}
                    viewStyle={{ backgroundColor: Colors.grey.bg }}
                    highlightedViewStyle={{ backgroundColor: Colors.primary }} />
                );
            })}
        </View>)
    }

export const StaticPaymentModes = () => {
    return <View style={AppStyles.flexRow}>
        {StoreStaticPaymentMethodsList.map((item, index) => (
            <View key={item['name']} style={{
                alignItems: 'center',
                paddingRight: 16
            }}><Image source={{ uri: getImagePath(`/images/oms/rops/icons/${item.logo}.svg`) }}
                style={{ width: 24, height: 24, borderRadius: 12 }} />
                <Text style={[TextStyle.text12, {
                    marginTop: 4, color: Colors.grey.text
                }]}>{item['name']}</Text>
            </View>
        ))}
    </View>
}

export function ChemistSiteLogo(props) {
    var chemistData = props.chemistData
    var nameInitials = getNameInitials(chemistData?.pharmacyName)
    if (!chemistData['logoBgColor']) {
        var bgColor = Colors.chemistSiteLogoBg[getRandInt0to10()]
        chemistData['logoBgColor'] = bgColor
    }
    return <View style={[AppStyles.borderViewRound, AppStyles.alignCenter,
    { backgroundColor: chemistData['logoBgColor'], width: 48, height: 48 }]}>
        <Text style={[TextStyle.text16, { color: Colors.white }]}>{nameInitials}</Text>
    </View>
}

export function ChemistStorePicture(props) {
    var chemistData = props.chemistData
    let uri = getChemistProfilePicUrl(chemistData)
    return <View style={[AppStyles.borderViewRound, AppStyles.alignCenter, { width: 48, height: 48 }]}>
        <Image source={{ uri: uri }} style={{ width: 46, height: 46, borderRadius: 23 }} />
    </View>
}